import Button from "../Button/Button";
import Icon from "../Icon/Icon";

export default function Chip({ label, onRemove, showRemove }) {
    return (
        <div className="flex items-center gap-1 bg-surface px-2 py-1 rounded-full text-sm">
            <span>{label}</span>
            {showRemove && ((
                <Button
                    variant="ghost"
                    onClick={() => onRemove(label)}
                >
                    <Icon icon="close" size={14} />
                </Button>
            ))}
        </div>
    );
}
